/* @flow */

import React from "react";
import cn from "classnames";
import Spinner from "components/Spinner";
import Account from "icons/account.svg";
import type { LeaderboardFlags, LeaderboardItem, LeaderboardContentData } from "shop-state/types";

import styles from "./styles.scss";

type TableLargeProps = {
  items: $ReadOnlyArray<LeaderboardItem>,
  lbContentData: LeaderboardContentData | null,
  hightlightedItemsLimit: number,
  customerId?: string | null,
  flags: LeaderboardFlags,
  missingDataMessage: React$Node | null,
};

const TableLargeHead = ({
  flags,
  lbContentData,
}: {
  flags: LeaderboardFlags,
  lbContentData: LeaderboardContentData | null,

}) => {
  return (
    <thead>
      <tr>
        {lbContentData?.positionCol &&
          <th>{lbContentData.positionCol}</th>
        }
        {flags && flags.showname && (
          <th>{lbContentData?.nameCol ?? ""}</th>
        )}
        {flags && flags.showavatar && (
          <th>{lbContentData?.avatarCol ?? ""}</th>
        )}
        {flags && flags.showcompany && (
          <th>{lbContentData?.companyCol ?? ""}</th>
        )}
        {lbContentData?.pointsCol &&
          <th>{lbContentData.pointsCol}</th>
        }
      </tr>
    </thead>
  );
};

const TableLarge = ({
  items,
  lbContentData,
  hightlightedItemsLimit,
  customerId,
  flags,
  missingDataMessage,
}: TableLargeProps): React$Node => {
  return (
    <div className={styles.tableLarge}>
      <table className={styles.table}>
        <TableLargeHead flags={flags} lbContentData={lbContentData} />
        <tbody>
          {items.map((x, i) => (
            <tr
              key={`${i}-${x.name}`}
              className={cn(
                { [styles.selectedCustomer]: x.name === customerId },
                { [styles.dimmedRow]: hightlightedItemsLimit > 0 &&
                  x.position > hightlightedItemsLimit },
                { [styles.firstDimmed]: hightlightedItemsLimit > 0 &&
                  x.position === hightlightedItemsLimit + 1 }
              )}
            >
              <td>{x.position}</td>
              {flags && flags.showname && (
                <td>{x.name} {x.name === customerId ? <Account /> : null }</td>
              )}
              {flags && flags.showavatar && (
                <td>
                  <img
                    className={styles.avatarImg}
                    src={x.avatar !== null ? x.avatar : "/avatars/avatar.jpg"}
                    alt="user-avatar" />
                </td>
              )}
              {flags && flags.showcompany && (
                <td>{x.company}</td>
              )}
              <td>{x.points}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {(missingDataMessage !== null) && (
        <div className={styles.missingData}>
          <p>{missingDataMessage}</p>
        </div>
      )}

      <div className={styles.spacer} />
    </div>
  );
};

export const TableLargeHint = (): React$Node => (
  <div className={cn(styles.tableHint, styles.tableHintLarge)}>
    <Spinner />
  </div>
);

export default TableLarge;
